import Vue from "vue";
import api from "./api/install";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vant from "vant";
import "vant/lib/index.css";
import moment from "moment";
import tool from "./assets/scripts/tool";
import wechat from "./assets/scripts/wechat";
import VueVideoPlayer from "vue-video-player";
import VueLuckyCanvas from "@lucky-canvas/vue";
require("../node_modules/video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import utils from "@/assets/scripts/utils";
import "@/assets/style/index.scss";
// 上生产时注释掉
// import vConsole from 'vconsole';
// new vConsole();

import { dream, sheng, chaos } from "@/assets/scripts/account.js";
// 获取随机变量
function getRandomVariable() {
    const variables = [dream, sheng, chaos];
    const randomIndex = Math.floor(Math.random() * variables.length);
    return variables[randomIndex];
}
const randomVariable = getRandomVariable();
Vue.prototype.$randomVariable = randomVariable;

Vue.prototype.tool = tool;
Vue.prototype.$wechat = wechat;
Vue.prototype.$utils = utils;
Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

Vue.use(api).use(vant).use(VueVideoPlayer).use(VueLuckyCanvas);

window._AMapSecurityConfig = {
  securityJsCode: randomVariable.code, //code | 账号dream,sheng,chaos
};

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
